export const DEFAULT_RESUME_COUNTRY_ID = '5';
